import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Button,
    Container,
    Dimmer,
    Divider,
    Form,
    Grid,
    Header,
    Icon,
    Loader,
    Segment
} from "semantic-ui-react";
import { push } from "react-router-redux";
import {
    get as loadClock,
    loadAdminClocks,
    getEmployees,
    adminSetActivity,
    adminSetDateRange,
    adminSetWarehouse,
    adminSetEmployee
} from "../../reducer/actions";
import {
    getAdminClocks,
    isLoading,
    getAdminSetActivity,
    getAdminSetDateRange,
    getAdminSetWarehouse,
    getAdminSetEmployee,
} from "../../reducer";
import { DateRangePicker } from "react-dates";
import moment from "moment";
import { CSVLink } from "react-csv";
import { HORIZONTAL_ORIENTATION, VERTICAL_ORIENTATION } from "react-dates/constants";
import { workingHours } from "../../helpers";
import { getActiveLanguage, getTranslate } from "react-localize-redux";


// Components
import WarehouseSelect from "../../components/WarehouseSelect";
import ActivitySelect from "../../components/ActivitySelect";
import EmployeeSelect from "../../components/EmployeeSelect";
import AdminClockReport from "./components/AdminClockReport";
import "react-dates/lib/css/_datepicker.css";

// Css


class ClockReports extends Component {

    constructor(props) {
        super(props);
        this.state = {
            focusedInput: null
        }
    }

    componentWillMount(){
        this.props.loadClock();
        this.props.loadEmployees();
        this.props.loadAdminClocks(this.props.dateRange.start,this.props.dateRange.end);
    }

    handleActivityChange(activity_id){
        this.props.setActivity(activity_id)
    }

    handleWarehouseChange(warehouse_id){
        this.props.setWarehouse(warehouse_id);
    }

    handleEmployeeChange(employee_id){
        this.props.setEmployee(employee_id);
    }

    render() {
        const smallDevice = window.matchMedia('(max-width: 400px)').matches;
        const orientation = smallDevice ? VERTICAL_ORIENTATION : HORIZONTAL_ORIENTATION;
        return (
                    <Container style={{padding: '3em 1em'}}>
                        <Dimmer active={this.props.isLoading}>
                            <Loader />
                        </Dimmer>
                        <Header as='h2' icon textAlign='center'>
                            <Icon name='clock' circular />
                        </Header>
                        <Grid
                            textAlign='center'
                            style={{ height: '100%' }}
                            verticalAlign='middle'
                        >
                            <Grid.Column width={16}>
                                <div>
                                    <Header as='h2' color='teal' textAlign='center'>
                                        {this.props.translate('clock.admin.report.header')}
                                    </Header>
                                    <Segment stacked>

                                        <Divider horizontal>{this.props.translate('general.filters')}</Divider>
                                        <DateRangePicker
                                            orientation={orientation}
                                            withPortal={smallDevice}
                                            startDate={this.props.dateRange.start} // momentPropTypes.momentObj or null,
                                            startDateId="start_date_id" // PropTypes.string.isRequired,
                                            endDate={this.props.dateRange.end} // momentPropTypes.momentObj or null,
                                            endDateId="end_date_id" // PropTypes.string.isRequired,
                                            isOutsideRange={(date) => date > moment()}
                                            onDatesChange={({ startDate, endDate }) => {this.props.setDateRange(startDate,endDate);this.props.loadAdminClocks(startDate,endDate)}} // PropTypes.func.isRequired,
                                            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                            onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                        />
                                        <Form>
                                            <ActivitySelect
                                                value={this.props.activity}
                                                onChange={(value) => {console.log(value);this.handleActivityChange(value)}}
                                                additionalActivities={[
                                                    {key:'empty', value:null, text: '-' },
                                                ]}
                                            />
                                            <WarehouseSelect
                                                value={this.props.warehouse}
                                                onChange={(value) => this.handleWarehouseChange(value)}
                                                additionalWarehouses={[
                                                    {key:'empty', value:null, text: '-' },
                                                ]}
                                            />
                                            <EmployeeSelect
                                                value={this.props.employee}
                                                onChange={(value) => this.handleEmployeeChange(value)}
                                                additionalEmployees={[
                                                    {key:'empty', value:null, text: '-' },
                                                ]}
                                            />
                                        </Form>

                                        <Divider horizontal>{this.props.translate('general.report')}</Divider>

                                        {this.props.clocks &&
                                        <AdminClockReport
                                            clocks={this.props.clocks}
                                            warehouse_id={this.props.warehouse}
                                            activity_id={this.props.activity}
                                            employee_id={this.props.employee}
                                        />
                                        }
                                        <Divider horizontal>Functions</Divider>
                                        {
                                            <div>
                                                <Button
                                                    fluid
                                                    primary
                                                    onClick={()=>{
                                                        this.props.newClock();
                                                    }}
                                                >
                                                    Neuer Arbeitszeiteintrag
                                                </Button>
                                                <Button
                                                    fluid
                                                    primary
                                                    onClick={()=>{
                                                        this.props.newTime();
                                                    }}
                                                >
                                                    Abwesenheit hinzufügen
                                                </Button>
                                            </div>
                                        }

                                        <Divider horizontal>{this.props.translate('clock.admin.report.reports.label')}</Divider>
                                        {this.props.clocks &&
                                        <div>
                                            <Button
                                                fluid
                                                primary
                                                as={CSVLink}
                                                target="_blank"
                                                data={this.getEmployeeReport()}
                                                filename={"employeeReport-"+Math.round((new Date()).getTime() / 1000)+".csv"}
                                            >
                                                {this.props.translate('clock.admin.report.reports.employee')}
                                            </Button>
                                        </div>
                                        }


                                    </Segment>
                                </div>
                            </Grid.Column>
                        </Grid>
                    </Container>
        );
    }

    getEmployeeReport(){
        const groupBy = function(xs, key) {
                          return xs.reduce(function(rv, x) {
                            (rv[x[key]] = rv[x[key]] || []).push(x);
                            return rv;
                          }, {});
                        };
        const header = ['Warehouse','Activity','Start-Date','Start-Time','End-Date','End-Time','Duration'];
        const c = groupBy(this.props.clocks,'user_id');
        let report = [['Employee Report'],[' ']];

        for(let i in c){
            report.push([' ']);
            report.push(['Employee Name:',c[i][0].user_name]);
            report.push(header);

            for(let x in c[i]){
                if(c[i][x].activity_name === 'ferien' || c[i][x].activity_name === 'krank'){
                    const duration = moment(c[i][x].end,'YYYY-MM-DD HH:mm:ss').diff(moment(c[i][x].start,'YYYY-MM-DD HH:mm:ss'), 'days') + 1;
                    report.push(
                        [c[i][x].warehouse_name,
                        c[i][x].activity_name,
                        moment(c[i][x].start,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY'),
                        '',
                        moment(c[i][x].end,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY'),
                        '',
                        '' + duration + ' Tage'
                        ]
                    );
                    continue;
                }
                c[i][x].end === null ?
                report.push([c[i][x].warehouse_name,c[i][x].activity_name,
                    moment(c[i][x].start,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY'),
                    moment(c[i][x].start,'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
                    '',
                    '',
                    workingHours(c[i][x].duration)]
                )
                :
                report.push([c[i][x].warehouse_name,c[i][x].activity_name,
                    moment(c[i][x].start,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY'),
                    moment(c[i][x].start,'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
                    moment(c[i][x].end,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY'),
                    moment(c[i][x].end,'YYYY-MM-DD HH:mm:ss').format('HH:mm'),
                    workingHours(c[i][x].duration)]
                );
            }
            report.push(['Total:','','','',workingHours(c[i].map(d => {
                if(d.activity_name === 'ferien' || d.activity_name === 'krank'){
                    return 0
                }
                return d.duration
            }).reduce((a,b)=>a+b))]);

            report.push(['Total Abwesenheit:','','','',''+c[i].map(d => {
                if(d.activity_name === 'ferien' || d.activity_name === 'krank'){
                    return moment(d.end,'YYYY-MM-DD HH:mm:ss').diff(moment(d.start,'YYYY-MM-DD HH:mm:ss'), 'days') + 1;
                }
                return 0
            }).reduce((a,b)=>a+b)+' Tage']);
        }
        return report;
    }

}


const mapStateToProps = state => ({
    isLoading: isLoading(state),
    clocks: getAdminClocks(state),
    translate: getTranslate(state.localize),
    lang: getActiveLanguage(state.localize),
    warehouse: getAdminSetWarehouse(state),
    employee: getAdminSetEmployee(state),
    activity: getAdminSetActivity(state),
    dateRange: getAdminSetDateRange(state),
});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch) => {
    return({
        loadClock: ()=>(dispatch(loadClock())),
        loadEmployees: ()=>(dispatch(getEmployees())),
        loadAdminClocks: (start,end)=>(dispatch(loadAdminClocks(start,end))),
        setWarehouse: (warehouse_id)=>(dispatch(adminSetWarehouse(warehouse_id))),
        setEmployee: (employee_id)=>(dispatch(adminSetEmployee(employee_id))),
        setActivity: (activity_id)=>(dispatch(adminSetActivity(activity_id))),
        setDateRange: (start,end)=>(dispatch(adminSetDateRange(start,end))),
        newClock: ()=>{dispatch(push('/clock/admin/newClock'))},
        newTime: ()=>{dispatch(push('/clock/admin/newTime'))},
    })
}


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ClockReports)



// WEBPACK FOOTER //
// ./src/scenes/Clock/scenes/AdminReports/index.js